// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownCircleFilledSvg from "@ant-design/icons-svg/es/asn/DownCircleFilled";
import AntdIcon from '../components/AntdIcon';

var DownCircleFilled = function DownCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleFilledSvg
  }));
};

DownCircleFilled.displayName = 'DownCircleFilled';
export default React.forwardRef(DownCircleFilled);